import React from "react";
// material ui
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

// ------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  // resposive_text_field: {
  //   [theme.breakpoints.down('md')]: {
  //   width:'170px',
  //   },
  // },
  root: {
    // [theme.breakpoints.down('md')]: {
    //   width:'170px !important',
    //   },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 500,
      color: "rgba(0, 0,  0)",
    },
    "& .css-1sumxir-MuiFormLabel-root-MuiInputLabel-root": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 500,
      color: "rgba(0, 0, 0)",
    },
    "& .css-1z7n62": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 500,
      color: "rgba(0, 0, 0)",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 400,
    },
  },
}));

// ------------------------------------------------------------

const FormTextField = ({
  label,
  type,
  id,
  name,
  value,
  onChange,
  onFocus,
  required,
  fullWidth,
  size,
  margin,
  variant,
  disabled,
  error,
  helperText,
  InputLabelProps,
  inputProps, 
  autoComplete,
  tabIndex,
  multiline,
  rows
}) => {
  const classes = useStyles();
  return (
    <TextField 
      // inputProps={{
      //   tabIndex: tabIndex,
      // }}
    // className={classes.resposive_text_field}
      label={label}
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      required={required}
      fullWidth={fullWidth}
      size={size}
      margin={margin}
      variant={variant}
      disabled={disabled}
      error={error}
      helperText={helperText}
      className={classes.root}
      sx={{ marginBottom: 0 }}
      InputLabelProps={InputLabelProps}
      inputProps={{tabIndex: tabIndex,...inputProps}}
      autoComplete={autoComplete}
       multiline={multiline}
       rows={rows}
    ></TextField>
  );
};

export default FormTextField;
